import { render, staticRenderFns } from "./PaymentsSuperadmin.vue?vue&type=template&id=6a1cbae3"
import script from "./PaymentsSuperadmin.vue?vue&type=script&lang=js"
export * from "./PaymentsSuperadmin.vue?vue&type=script&lang=js"
import style0 from "./PaymentsSuperadmin.vue?vue&type=style&index=0&id=6a1cbae3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports